(function () {
  'use strict';

  function updateBadge(root, variantId) {
    if (!root) return;

    const badge = root.querySelector('[data-price-per-day-root]');
    const badgeText = root.querySelector('[data-price-per-day-text]');

    if (!badge || !badgeText || !variantId) {
      if (badge) badge.hidden = true;
      return;
    }

    const variantData = root.querySelector(
      `[data-price-per-day-variant][data-variant-id="${variantId}"]`
    );

    if (
      !variantData ||
      variantData.dataset.showBadge !== 'true' ||
      !variantData.dataset.pricePerDayText
    ) {
      badge.hidden = true;
      return;
    }

    badgeText.textContent = variantData.dataset.pricePerDayText;
    badge.hidden = false;
    root.dataset.currentVariantId = String(variantId);
  }

  function initRoot(root) {
    if (!root || root.dataset.pricePerDayInitialized === 'true') return;

    root.dataset.pricePerDayInitialized = 'true';

    if (root.dataset.currentVariantId) {
      updateBadge(root, root.dataset.currentVariantId);
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-price-per-day-badge-container]')
      .forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('product:variant-change', function (evt) {
    const variant = evt.detail && evt.detail.variant;
    const variantId = variant && variant.id ? String(variant.id) : '';

    document
      .querySelectorAll('[data-price-per-day-badge-container]')
      .forEach(function (root) {
        const matchingVariant = variantId
          ? root.querySelector(
              `[data-price-per-day-variant][data-variant-id="${variantId}"]`
            )
          : null;

        if (matchingVariant || !variantId) {
          updateBadge(root, variantId);
        }
      });
  });

  document.addEventListener('quickview:loaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initAll(evt.target);
  });
})();